import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { warningTypes } from '../../constants';
import { messages } from '../../messages';
import style from './invalid-scan-warning-modal.module.less';

const ExtraProduct = () => (
  <>
    <FormattedMessage {...messages.invalidScanExtraProduct} />
    <span className={style.subtext}>
      <FormattedMessage {...messages.invalidScanAlreadyVerified} />
    </span>
  </>
);

const IncorrectProduct = () => (
  <>
    <FormattedMessage {...messages.invalidScanIncorrectProduct} />
    <span className={style.subtext}>
      <FormattedMessage {...messages.invalidScanNotInOrder} />
    </span>
  </>
);

const ScannedOrderNumber = () => <FormattedMessage {...messages.scannedOrderNumber} />;

export const WarningMessage = ({ warningType }) => {
  const typeMap = {
    [warningTypes.extraProduct]: ExtraProduct,
    [warningTypes.incorrectProduct]: IncorrectProduct,
    [warningTypes.scannedOrderNumber]: ScannedOrderNumber,
  };

  return typeMap[warningType]() ?? <IncorrectProduct />;
};

WarningMessage.propTypes = {
  warningType: PropTypes.oneOf([warningTypes.extraProduct, warningTypes.incorrectProduct, warningTypes.scannedOrderNumber]).isRequired,
};
